import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base'
import { isForeclosure } from './utils'

/**
 * Only used in condensed mode at this time.
 */
class NewlyListedBadge extends ListingBadge {
  static title = 'Newly Listed'

  static summary = ''

  static titleIcon = 'certificate'

  static titleV2 = 'New'
  static renderPriorityV2 = listing =>
    isForeclosure(listing)
      ? BADGE_ORDER_PRIORITY.FIFTH
      : BADGE_ORDER_PRIORITY.THIRD

  static content = null // not intended for expanded mode - at this time

  static renderPriority = BADGE_ORDER_PRIORITY.FIRST

  static shouldBeIncluded(listing, badgeMode) {
    // check for condensed mode, hide for expanded
    return (
      (badgeMode === BADGE_MODE.CONDENSED || badgeMode === BADGE_MODE.V2) &&
      listing.primary_property?.is_newly_listed
    )
  }

  static shouldBeIncludedV2 = this.shouldBeIncluded
}

export default NewlyListedBadge
